import ApiClient from "@/lib/api-client"

import { PAYMENT_METHOD_TYPES } from "@/lib/checkout-utils"

export default {
  namespaced: true,

  state: {
    pastDueSubscriptions: []
  },

  mutations: {
    setPastDueSubscriptions(state, subscriptions) {
      state.pastDueSubscriptions = subscriptions
    }
  },

  actions: {
    purchase(
      _,
      {
        productId,
        userId,
        billingEmail,
        billingName,
        paymentMethodId,
        paymentMethodType = PAYMENT_METHOD_TYPES.CREDIT_CARD,
        couponCode
      }
    ) {
      return ApiClient.post(`/products/${productId}/purchase`, {
        user_id: userId,
        billing_email: billingEmail,
        billing_name: billingName,
        payment_method_id: paymentMethodId,
        payment_method_type: paymentMethodType,
        coupon_code: couponCode
      })
    },

    purchaseIap(_, { productId, transactionId, originalTransactionId }) {
      return ApiClient.post(`/products/${productId}/purchase/iap`, {
        transaction_id: transactionId,
        original_transaction_id: originalTransactionId
      })
    },

    fetchIntent(_, { productId, coupon = null }) {
      return ApiClient.post(`/products/${productId}/intent`, { coupon })
    },

    fetchProduct(_, id) {
      return ApiClient.get(`/products/${id}`).then(res => {
        return res.data
      })
    },

    fetchMultipleProducts(_, ids) {
      return ApiClient.get(`/products/list`, { params: { ids } }).then(res => {
        return res.data.products
      })
    },

    hasActivePurchase(_, id) {
      return ApiClient.get(`/products/${id}/has_active_purchase`).then(res => {
        return res.data.has_active_purchase
      })
    },

    applyCoupon(_, { productId, couponCode }) {
      return ApiClient.post(`/products/${productId}/apply_coupon`, {
        coupon_code: couponCode
      })
    },

    paySubscription(_, id) {
      return ApiClient.post(`/subscriptions/${id}/pay`)
    },

    updatePaymentMethod(_, { subscriptionId, paymentMethodId }) {
      return ApiClient.post(
        `/subscriptions/${subscriptionId}/update_payment_method`,
        { payment_method_id: paymentMethodId }
      )
    },

    fetchPurchasedItems(_, productId) {
      return ApiClient.get(`/products/${productId}/purchased_items`).then(
        res => {
          return res.data
        }
      )
    }
  },

  getters: {
    getAppProducts(_, __, state) {
      return state.global?.access.app_products || []
    },

    hasPastDueSubscription(state) {
      return state.pastDueSubscriptions.length > 0
    },

    hasPastDueSubscriptionForProduct(state) {
      return productId =>
        state.pastDueSubscriptions.some(sub => sub.product_id === productId)
    },

    getPastDueSubscriptionForProduct(state) {
      return productId =>
        state.pastDueSubscriptions.find(sub => sub.product_id === productId)
    }
  }
}
